import { toast } from 'react-toastify';
import {
  GET_EVENTS_LIST,
  SET_EVENT_TYPES,
} from '../actionTypes';
import api from '../../api';
import { showToastError } from '../../components/utils';

export function getEventTypes() {
  return (dispatch) => {
    api.get('eventTypes')
      .then((res) => {
        dispatch({
          type: SET_EVENT_TYPES,
          payload: res.data,
        });
      });
  };
}
export function deleteDone(id) {
  return () => {
    api.delete('eventPlans', id).then(() => {
      window.location.reload();
    });
  };
}
export function getEventList(params) {
  return (dispatch) => {
    api.get('eventPlans', params)
      .then((res) => {
      	// console.log(
      	// 	res,
	      // );
        dispatch({
          type: GET_EVENTS_LIST,
          payload: res.data,
        });
      });
  };
}
